import { render, staticRenderFns } from "./ServiceTypeDetails.vue?vue&type=template&id=bb352cea&"
import script from "./ServiceTypeDetails.vue?vue&type=script&lang=ts&"
export * from "./ServiceTypeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports